import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CLOSED_LA_COOKIE } from 'constants/cookies';
import { HYDRA_PERSONALIZATION_MARKER } from 'constants/hydraTests';
import { inIframe } from 'helpers/CheckoutUtils';
import { getAssignmentGroup, triggerAssignment } from 'actions/ab';
import { onCloseLoginAssistantClick, onLoginFromLoginAssistantClick, onRedirectFromLoginAssistantClick, onShowLoginAssistant } from 'store/ducks/loginAssistant/actions';
import llamaImage from 'images/llama-circle.svg';
import HtmlText from 'components/common/HtmlText';

import css from 'styles/components/loginAssistant.scss';
import { close as modalClose } from 'styles/components/common/modal.scss';

export class LoginAssistant extends Component {
  state = {
    isShown: true
  };

  componentDidMount() {
    const { marketplace: { showLoginAssistant } } = this.context;
    const { hideLADueToCustomerClosedIt, isRecognizedCustomer, triggerAssignment, onShowLoginAssistant } = this.props;
    if (showLoginAssistant && !hideLADueToCustomerClosedIt && !isRecognizedCustomer) {
      triggerAssignment(HYDRA_PERSONALIZATION_MARKER);
      onShowLoginAssistant();
    }
  }

  onHideLoginAssistantFromLinkClick = e => {
    e.preventDefault();
    this.setState({ isShown: false });
    this.props.onCloseLoginAssistantClick();
  };

  onCtaClick = e => {
    e.preventDefault();

    const {
      content: {
        ctaType,
        ctaLink
      } = {},
      locationBeforeTransitions: { pathname },
      onLoginFromLoginAssistantClick,
      onRedirectFromLoginAssistantClick
    } = this.props;

    if (ctaType === 'login') {
      onLoginFromLoginAssistantClick(pathname);
    } else {
      onRedirectFromLoginAssistantClick(ctaLink);
    }
  };

  render() {
    const { marketplace: { showLoginAssistant }, testId } = this.context;
    if (!showLoginAssistant || inIframe()) {
      return null;
    }

    const {
      content,
      hideLADueToCustomerClosedIt,
      isRecognizedCustomer,
      hydraPersonalizationMarker
    } = this.props;

    const {
      headerContent,
      bubbleContent,
      ctaText
    } = content || {};

    const { isShown } = this.state;

    if ((isShown && hideLADueToCustomerClosedIt) || isRecognizedCustomer) {
      return null;
    }

    const personalizedImage = !!hydraPersonalizationMarker && <span className={css.pRecMrkSmall} aria-label="Personalization icon" />;

    return (
      <aside
        data-test-id={testId('loginAssistant')}
        className={cn(css.wrapper, { [css.fadeOut]: !isShown })}
        role="dialog">
        <div className={css.modalHeader}>
          <p className={css.header}>
            {personalizedImage}
            {headerContent}
          </p>
          <button
            type="button"
            onClick={this.onHideLoginAssistantFromLinkClick}
            className={modalClose}
            data-test-id={testId('closeModal')}
            aria-label="Close" />
        </div>

        <div className={css.lasBody}>
          <div className={css.speechBubble}>
            <HtmlText text={bubbleContent} />
          </div>
          <img src={llamaImage} alt="" />
        </div>

        <div className={css.footer}>
          <form action={'tbd'} method="post">
            <button
              type="button"
              disabled={false}
              onClick={this.onHideLoginAssistantFromLinkClick}
              className={css.cancelBtn}
              data-test-id={testId('dismissBtn')}>Dismiss</button>

            {!!ctaText && <button
              type="submit"
              className={css.loginBtn}
              onClick={this.onCtaClick}
              data-test-id={testId('loginAssistantCta')}>{ctaText}</button>}
          </form>
        </div>
      </aside>
    );
  }
}

function mapStateToProps(state) {
  const {
    cookies: {
      ['x-main']: isRecognizedCustomer,
      [CLOSED_LA_COOKIE]: hideLADueToCustomerClosedIt
    },
    routing: { locationBeforeTransitions }
  } = state;

  return {
    isRecognizedCustomer: !!isRecognizedCustomer,
    hideLADueToCustomerClosedIt: !!hideLADueToCustomerClosedIt,
    hydraPersonalizationMarker: getAssignmentGroup(HYDRA_PERSONALIZATION_MARKER, state),
    locationBeforeTransitions
  };
}

LoginAssistant.contextTypes = {
  marketplace: PropTypes.object,
  testId: PropTypes.func
};

export default connect(mapStateToProps, {
  onCloseLoginAssistantClick,
  onLoginFromLoginAssistantClick,
  onRedirectFromLoginAssistantClick,
  onShowLoginAssistant,
  triggerAssignment
})(LoginAssistant);
